module.exports = __webpack_public_path__ + "static/design-cal-7a9ea25432c39e0808a214b2afde3b38.webm";